import { StatisticsCard, CompartmentCard } from "@/src/components/cards";
import { getDataSet } from "@/src/components/chart";
import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import { StatisticsReport } from "@/src/data/allTypes";
import { Line } from "react-chartjs-2";
import { IoMdMale } from "react-icons/io";
import { IoFemale } from "react-icons/io5";
import { MdOutlineGridGoldenratio } from "react-icons/md";
import { TbSum } from "react-icons/tb";
import ReportPatientsList from "./reportPatientsList";

export default function StatisticsReportDrawer({
  data,
}: {
  data: StatisticsReport;
}) {
  return (
    <div className="c1 gap10">
      <div className="c4 mc1 gap10">
        <StaggeredAnimation index={0}>
          <StatisticsCard
            icon={<IoMdMale />}
            color="blue"
            title="Hommes"
            value={data.males}
          />
        </StaggeredAnimation>
        <StaggeredAnimation index={1}>
          <StatisticsCard
            icon={<IoFemale />}
            color="purple"
            title="Femmes"
            value={data.females}
          />
        </StaggeredAnimation>
        <StaggeredAnimation index={2}>
          <StatisticsCard
            color="orange"
            title="Ratio"
            icon={<MdOutlineGridGoldenratio />}
            value={
              data.females == 0
                ? "-"
                : parseFloat((data.males / data.females)?.toString()).toFixed(2)
            }
          />
        </StaggeredAnimation>
        <StaggeredAnimation index={3}>
          <StatisticsCard
            color="green"
            title="Total"
            icon={<TbSum />}
            value={data.females + data.males}
          />
        </StaggeredAnimation>
      </div>
      <CompartmentCard title="Courbes">
        <Line
          options={{
            responsive: true,
            plugins: {
              legend: {
                position: "top" as const,
              },
              title: {
                display: true,
                text: "Patients par jour",
              },
            },
            scales: {
              x: {
                type: "time",
              },
            },
          }}
          data={{
            datasets: [
              getDataSet({
                label: "Patients",
                color: "rgb(54, 162, 235)",
                counts: data?.patientsDates,
              }),
            ],
          }}
        />
      </CompartmentCard>
      <ReportPatientsList report={data}></ReportPatientsList>
    </div>
  );
}
